import { render, staticRenderFns } from "./CreativesDiscrepancyModal.vue?vue&type=template&id=d12cdd08&scoped=true"
import script from "./CreativesDiscrepancyModal.vue?vue&type=script&lang=js"
export * from "./CreativesDiscrepancyModal.vue?vue&type=script&lang=js"
import style0 from "./CreativesDiscrepancyModal.vue?vue&type=style&index=0&id=d12cdd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12cdd08",
  null
  
)

export default component.exports